import { AnyAction } from 'redux';
import { ILoadingError } from '#/types/global';
import { IAlbums } from './artistAlbums';
import {
  createActionAlbumReset,
  createActionAlbumSetAlbum,
  createActionAlbumSetErrorDetails,
  createActionAlbumSetIsFollowed,
  createActionAlbumSetOtherAlbums,
  createActionAlbumSetTrackIsFollowed,
  createActionAlbumSetTracks,
  createActionAlbumStartLoading,
  createActionAlbumStopLoading,
} from '../actions/album';
import { IArtistAlbums } from '#/types/API/artists';

export interface IAlbumState {
  album?: IAlbums;
  other_albums?: IArtistAlbums['items'];
}

type TState = IAlbumState & ILoadingError;

const initialState: TState = {
  _loading: true,
  _error: false,
};

const album = (state: TState = initialState, action: AnyAction): TState => {
  if (createActionAlbumSetAlbum.doesMatch(action)) {
    return { ...state, album: action.payload };
  }

  if (createActionAlbumSetOtherAlbums.doesMatch(action)) {
    return { ...state, other_albums: action.payload };
  }

  if (createActionAlbumStartLoading.doesMatch(action)) {
    return { ...state, _loading: true };
  }

  if (createActionAlbumStopLoading.doesMatch(action)) {
    return { ...state, _loading: false };
  }

  if (createActionAlbumSetErrorDetails.doesMatch(action)) {
    return { ...state, _error: action.payload };
  }

  if (createActionAlbumSetIsFollowed.doesMatch(action)) {
    if (state.album) {
      return {
        ...state,
        album: { ...state.album, favorite: action.payload.follow },
      };
    }
    return state;
  }

  if (createActionAlbumSetTrackIsFollowed.doesMatch(action)) {
    if (state.album) {
      const indexTrack = state.album.tracks.items.findIndex(
        (track) => track.id === action.payload.track
      );
      if (indexTrack !== -1) {
        const newAlbum = { ...state.album };
        newAlbum.tracks.items[indexTrack].favorite = action.payload.follow;
        return { ...state, album: newAlbum };
      }
    }
    return state;
  }

  if (createActionAlbumSetTracks.doesMatch(action)) {
    if (state.album) {
      return {
        ...state,
        album: { ...state.album, tracks: action.payload.tracks },
      };
    }
    return state;
  }

  if (createActionAlbumReset.doesMatch(action)) {
    return initialState;
  }

  return state;
};

export default album;
